export default __webpack_public_path__ + "static/media/a-3d.0716bb39.svg";